import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { UrlService } from '@core/services/url.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReportDataFetcherService {
  readonly #httpClient = inject(HttpClient);
  readonly #urlService = inject(UrlService);

  public fetchData(projectId: string, jobId: string, taskId: string): Observable<Record<string, string>> {
    const url = this.#urlService.getUrl(`report-template/hub/${projectId}/job/${jobId}/task/${taskId}/report/bindings`);
    return this.#httpClient.get<Record<string, string>>(url);
  }
}
